<div
  class="c-form__item u-layout-auto {{ width }}"
  [ngClass]="{ 'c-form__error': errorMessage.length > 0 }"
>
  <label for="ip">{{ label }} <span *ngIf="required">*</span></label>
  <input
    id="ip"
    type="text"
    (change)="ipAddressChanged($event)"
    (keyup)="ipAddressChanged($event)"
    [value]="address"
    [attr.required]="required"
    [placeholder]="placeHolder"
  />
  <div class="c-form__message" *ngIf="errorMessage.length > 0">
    {{ errorMessage }}
  </div>
</div>

<div
  ls-dynamic-translation
  id="This is not a valid IP address"
  i18n="IP input|Invalid IP address error message @@errorMessageInvalidIP"
>
  This is not a valid IP address
</div>
<div
  ls-dynamic-translation
  id="IP address is required"
  i18n="IP input|Required IP address error message @@errorMessageRequiredIP"
>
  IP address is required
</div>
